/* PureClean Theme JS · Vanilla IIFE · window.PureClean { moneyFormat, cartUrl, rootUrl } */
(function(){
'use strict';
var PC=window.PureClean||{},root=PC.rootUrl||'';
/* routes.root_url is "/" on a normal shop, so naive root+'/cart/add.js'
   produced '//cart/add.js' — a protocol-relative URL the browser resolved to
   https://cart/add.js. Every cart request silently went to a dead host. */
var base=root.replace(/\/+$/,'');
function u(path){return base+path;}
var $=function(s,p){return(p||document).querySelector(s);};
var $$=function(s,p){return(p||document).querySelectorAll(s);};

// Utilities

function debounce(fn,w){var t;return function(){var c=this,a=arguments;clearTimeout(t);t=setTimeout(function(){fn.apply(c,a)},w);};}

function throttle(fn,l){
  var w=false,la=null,lc=null;
  return function(){
    if(!w){fn.apply(this,arguments);w=true;setTimeout(function(){w=false;if(la){fn.apply(lc,la);la=lc=null;}},l);}
    else{la=arguments;lc=this;}
  };
}

var _ft={el:null,prev:null,fn:null};
var FOCUS='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

function trapFocus(el){
  if(!el)return;_ft.prev=document.activeElement;_ft.el=el;
  _ft.fn=function(e){
    if(e.key!=='Tab')return;var f=$$(FOCUS,el);if(!f.length)return;
    var fi=f[0],la=f[f.length-1];
    if(e.shiftKey&&document.activeElement===fi){e.preventDefault();la.focus();}
    else if(!e.shiftKey&&document.activeElement===la){e.preventDefault();fi.focus();}
  };
  document.addEventListener('keydown',_ft.fn);
  var ff=$(FOCUS,el);if(ff)ff.focus();
}

function releaseFocus(){
  if(_ft.fn)document.removeEventListener('keydown',_ft.fn);
  if(_ft.prev&&_ft.prev.focus)_ft.prev.focus();
  _ft.el=_ft.fn=_ft.prev=null;
}

function formatMoney(cents){
  if(typeof cents==='string')cents=cents.replace('.','');
  cents=parseInt(cents,10)||0;
  var fmt=PC.moneyFormat||'${{ amount }}';
  var sep=function(s,c){return String(s).replace(/\B(?=(\d{3})+(?!\d))/g,c);};
  var d=Math.floor(Math.abs(cents)/100),r=Math.abs(cents)%100,sg=cents<0?'-':'',p=(r<10?'0':'')+r;
  var dr=sep(Math.round(Math.abs(cents)/100),',');
  /* Shopify's placeholders, per its money-format spec:
     {{amount}} 1,134.65 · {{amount_no_decimals}} 1,135
     {{amount_with_comma_separator}} 1.134,65 · {{..._no_decimals_with_comma_separator}} 1.135
     {{amount_with_space_separator}} 1 134,65 · {{..._no_decimals_with_space_separator}} 1 135
     `amount` must stay last: it is a prefix of every other key. */
  var m={amount_with_apostrophe_separator:sg+sep(d,"'")+'.'+p,amount_no_decimals_with_comma_separator:sg+sep(Math.round(Math.abs(cents)/100),'.'),amount_with_comma_separator:sg+sep(d,'.')+','+p,amount_no_decimals_with_space_separator:sg+sep(Math.round(Math.abs(cents)/100),' '),amount_with_space_separator:sg+sep(d,' ')+','+p,amount_no_decimals:sg+dr,amount:sg+sep(d,',')+'.'+p};
  var out=fmt;for(var k in m)out=out.replace(new RegExp('\\{\\{\\s*'+k+'\\s*\\}\\}','g'),m[k]);
  return out;
}

function fetchCfg(type){return{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/'+(type||'json')}};}

function announce(msg){
  var r=document.getElementById('pc-a11y');
  if(!r){r=document.createElement('div');r.id='pc-a11y';r.setAttribute('role','status');r.setAttribute('aria-live','polite');r.setAttribute('aria-atomic','true');r.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';document.body.appendChild(r);}
  r.textContent='';setTimeout(function(){r.textContent=msg;},50);
}

// Scroll Reveal

function initScrollReveal(){
  var els=$$('[data-reveal]');if(!els.length)return;
  if((window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)||!('IntersectionObserver' in window)){
    for(var i=0;i<els.length;i++)els[i].classList.add('is-revealed');return;
  }
  var obs=new IntersectionObserver(function(ent){
    for(var i=0;i<ent.length;i++){if(!ent[i].isIntersecting)continue;var el=ent[i].target,dl=el.getAttribute('data-reveal-delay');if(dl)el.style.transitionDelay=dl+'ms';el.classList.add('is-revealed');obs.unobserve(el);}
  },{threshold:0.15,rootMargin:'0px 0px -60px 0px'});
  for(var j=0;j<els.length;j++)obs.observe(els[j]);
}

// Sticky Header

function initStickyHeader(){
  var h=$('.pc-header');if(!h)return;var lastY=0,hH=h.offsetHeight;
  window.addEventListener('scroll',throttle(function(){
    var y=window.scrollY;
    if(y>50)h.classList.add('pc-header--scrolled');else h.classList.remove('pc-header--scrolled','pc-header--hidden');
    if(y>hH){if(y>lastY)h.classList.add('pc-header--hidden');else{h.classList.remove('pc-header--hidden');h.classList.add('pc-header--scrolled');}}
    lastY=y;
  },100),{passive:true});
}

// Mobile Menu

var menuOpen=false;
function openMenu(){
  var m=$('.pc-mobile-menu'),o=$('.pc-overlay');if(!m)return;
  m.classList.add('pc-mobile-menu--open');if(o)o.classList.add('pc-overlay--active');
  document.body.style.overflow='hidden';menuOpen=true;trapFocus(m);announce('Navigation menu opened');
}
function closeMenu(){
  var m=$('.pc-mobile-menu'),o=$('.pc-overlay');if(!m)return;
  m.classList.remove('pc-mobile-menu--open');if(o)o.classList.remove('pc-overlay--active');
  document.body.style.overflow='';menuOpen=false;releaseFocus();announce('Navigation menu closed');
}
function toggleMenu(){menuOpen?closeMenu():openMenu();}
/* No init needed — the menu is driven by the global [data-action] delegation below. */

// Cart Drawer

var cartOpen=false;
function openCart(){
  var d=$('.pc-cart-drawer'),o=$('.pc-overlay');if(!d)return;if(menuOpen)closeMenu();
  d.classList.add('pc-cart-drawer--open');if(o)o.classList.add('pc-overlay--active');
  document.body.style.overflow='hidden';cartOpen=true;trapFocus(d);announce('Cart drawer opened');
}
function closeCart(){
  var d=$('.pc-cart-drawer'),o=$('.pc-overlay');if(!d)return;
  d.classList.remove('pc-cart-drawer--open');if(o)o.classList.remove('pc-overlay--active');
  document.body.style.overflow='';cartOpen=false;releaseFocus();announce('Cart drawer closed');
}

function updateCount(n){var b=$$('.pc-header__cart-count');for(var i=0;i<b.length;i++){b[i].textContent=n;n>0?b[i].removeAttribute('hidden'):b[i].setAttribute('hidden','');}}

function refreshCart(){
  return fetch(u('/?sections=cart-drawer'))
    .then(function(r){if(!r.ok)throw new Error('fail');return r.json();})
    .then(function(d){
      var html=d['cart-drawer'];if(!html)return;
      var t=document.createElement('div');t.innerHTML=html;
      /* Replace the whole panel: the progress bar, COD note, subtotal and
         checkout button all live outside the item list and are cart-state
         dependent, so swapping only the item list leaves them stale. */
      var next=t.querySelector('.pc-cart-drawer__panel'),cur=$('.pc-cart-drawer__panel');
      if(next&&cur){cur.innerHTML=next.innerHTML;return fetch(u('/cart.js'));}
      var c=document.getElementById('cart-drawer-content');
      if(c){var inner=t.querySelector('#cart-drawer-content');c.innerHTML=inner?inner.innerHTML:html;}
      return fetch(u('/cart.js'));
    })
    .then(function(r){return r&&r.ok?r.json():null;})
    .then(function(cart){if(!cart)return;updateCount(cart.item_count);})
    .catch(function(e){console.error('PureClean: cart refresh',e);});
}

function handleATC(form){
  if(!form)return;
  var btn=$('[data-add-to-cart],[type="submit"]',form),orig=btn?btn.innerHTML:'';
  var err=$('.pc-product-form__error,.pc-form__error',form);
  if(btn){btn.disabled=true;btn.classList.add('pc-btn--loading');btn.setAttribute('aria-busy','true');}
  if(err){err.textContent='';err.hidden=true;}
  var fd=new FormData(form),body={};
  /* UI controls that live inside the form (tier radios and the like) are
     not cart fields — keep them out of the payload. */
  fd.forEach(function(v,k){if(k.indexOf('pc-')!==0)body[k]=v;});
  if(body.quantity)body.quantity=parseInt(body.quantity,10)||1;
  if(body.id)body.id=parseInt(body.id,10);
  var cfg=fetchCfg();cfg.body=JSON.stringify(body);
  fetch(u('/cart/add.js'),cfg)
    .then(function(r){if(!r.ok)return r.json().then(function(d){throw new Error(d.description||d.message||'Could not add item');});return r.json();})
    .then(function(){announce('Item added to cart');return refreshCart();})
    .then(function(){openCart();})
    .catch(function(e){if(err){err.textContent=e.message||'Something went wrong.';err.hidden=false;}announce('Error: '+(e.message||'Could not add item'));})
    .finally(function(){if(btn){btn.disabled=false;btn.classList.remove('pc-btn--loading');btn.setAttribute('aria-busy','false');btn.innerHTML=orig;}});
}

function handleQty(button){
  if(!button)return;
  var line=parseInt(button.getAttribute('data-line'),10),qty=parseInt(button.getAttribute('data-quantity'),10);
  if(isNaN(line))return;if(isNaN(qty))qty=0;
  var cfg=fetchCfg();cfg.body=JSON.stringify({line:line,quantity:qty});
  var btns=$$('[data-cart-quantity]');for(var i=0;i<btns.length;i++)btns[i].disabled=true;
  fetch(u('/cart/change.js'),cfg)
    .then(function(r){if(!r.ok)throw new Error('fail');return r.json();})
    .then(function(){return refreshCart();})
    .then(function(){announce(qty===0?'Item removed':'Cart updated');})
    .catch(function(){announce('Error updating cart');})
    .finally(function(){var b=$$('[data-cart-quantity]');for(var j=0;j<b.length;j++)b[j].disabled=false;});
}

function initCartDrawer(){
  /* Add to cart from the button click, never from a form submit event:
     Shopify's pixel manager reports submits of /cart/add forms to Meta as an
     AddToCart built from the form fields (no price for the twin pack), on top
     of the real one from /cart/add.js. */
  document.addEventListener('click',function(e){var b=e.target.closest('[data-add-to-cart]');if(!b)return;var f=b.closest('[data-product-form]');if(!f)return;e.preventDefault();handleATC(f);});
  document.addEventListener('keydown',function(e){if(e.key!=='Enter')return;var f=e.target.closest('[data-product-form]');if(!f||e.target.tagName==='TEXTAREA'||e.target.tagName==='BUTTON')return;e.preventDefault();handleATC(f);});
  document.addEventListener('submit',function(e){var f=e.target.closest('[data-product-form]');if(!f)return;e.preventDefault();handleATC(f);});
  document.addEventListener('click',function(e){
    var qb=e.target.closest('[data-cart-quantity]');if(qb){e.preventDefault();handleQty(qb);return;}
    var rb=e.target.closest('[data-cart-remove]');if(rb){e.preventDefault();rb.setAttribute('data-quantity','0');handleQty(rb);}
  });
}

// Product Form / Variant Selector

function initProductForm(){
  var jEl=$('[data-product-json]');if(!jEl)return;
  var product;try{product=JSON.parse(jEl.textContent);}catch(e){return;}
  if(!product||!product.variants)return;

  function findV(opts){
    for(var i=0;i<product.variants.length;i++){var v=product.variants[i],ok=true;for(var j=0;j<opts.length;j++)if(v.options[j]!==opts[j]){ok=false;break;}if(ok)return v;}return null;
  }
  function getOpts(){
    var opts=[],groups=$$('[data-option-position]');
    if(!groups.length){
      var pos={},radios=$$('[data-variant-option]');
      for(var i=0;i<radios.length;i++){var r=radios[i],p=parseInt(r.getAttribute('data-option-position'),10);if(!isNaN(p)&&(r.checked||r.classList.contains('pc-variant-option--selected')))pos[p]=r.value||r.getAttribute('data-value');}
      var keys=Object.keys(pos).sort();for(var k=0;k<keys.length;k++)opts.push(pos[keys[k]]);
    }else{for(var m=0;m<groups.length;m++){var sel=$('input:checked,.pc-variant-option--selected',groups[m]);if(sel)opts.push(sel.value||sel.getAttribute('data-value')||sel.textContent.trim());}}
    return opts;
  }
  function updateUI(v){
    var pEl=$('[data-product-price]');if(pEl&&v)pEl.textContent=formatMoney(v.price);
    var cEl=$('[data-compare-price]');
    if(cEl){if(v&&v.compare_at_price&&v.compare_at_price>v.price){cEl.textContent=formatMoney(v.compare_at_price);cEl.hidden=false;}else{cEl.textContent='';cEl.hidden=true;}}
    var badge=$('[data-sale-badge]');
    var onSale=v&&v.compare_at_price&&v.compare_at_price>v.price,saveTxt=onSale?'Save '+formatMoney(v.compare_at_price-v.price):'';
    if(badge){if(onSale){badge.textContent=saveTxt;badge.hidden=false;badge.style.display='';}else badge.hidden=true;}
    var ib=$('[data-image-save-badge]');if(ib){if(onSale){ib.textContent=saveTxt;ib.hidden=false;}else ib.hidden=true;}
    var ab=$('[data-add-to-cart]'),at=$('[data-add-to-cart-text]');
    if(ab){if(!v){ab.disabled=true;if(at)at.textContent='Unavailable';}else if(!v.available){ab.disabled=true;if(at)at.textContent='Sold Out';}else{ab.disabled=false;if(at)at.textContent='Add to Cart';}}
    var idIn=$('input[name="id"][type="hidden"],select[name="id"]');if(idIn&&v)idIn.value=v.id;
    if(v)history.replaceState(null,'',location.pathname+'?variant='+v.id);
    if(v&&v.featured_image&&v.featured_image.src){
      var norm=v.featured_image.src.replace(/https?:/,'').split('?')[0],thumbs=$$('.pc-product__media-thumb');
      for(var i=0;i<thumbs.length;i++){var ts=(thumbs[i].getAttribute('data-full-src')||thumbs[i].src||'').replace(/https?:/,'').split('?')[0];if(ts&&(norm.indexOf(ts)!==-1||ts.indexOf(norm)!==-1)){thumbs[i].click();break;}}
    }
  }
  document.addEventListener('change',function(e){if(!e.target.closest('[data-variant-option]'))return;updateUI(findV(getOpts()));});
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-variant-option][data-value]');if(!btn||btn.tagName==='INPUT')return;e.preventDefault();
    var grp=btn.closest('[data-option-position]');
    if(grp){var sibs=$$(('[data-variant-option]'),grp);for(var i=0;i<sibs.length;i++){sibs[i].classList.remove('pc-variant-option--selected');sibs[i].setAttribute('aria-checked','false');}}
    btn.classList.add('pc-variant-option--selected');btn.setAttribute('aria-checked','true');updateUI(findV(getOpts()));
  });
}

// Sticky ATC

function initStickyATC(){
  var main=$('[data-add-to-cart]'),bar=$('.pc-sticky-atc');
  if(!main||!bar||!('IntersectionObserver' in window))return;
  new IntersectionObserver(function(ent){for(var i=0;i<ent.length;i++)bar.classList.toggle('pc-sticky-atc--visible',!ent[i].isIntersecting);},{threshold:0}).observe(main);
  var sb=$('[data-sticky-atc-btn]',bar);
  if(sb)sb.addEventListener('click',function(e){e.preventDefault();var f=main.closest('[data-product-form]');if(f)handleATC(f);else main.click();});
}

// Quiz

function initQuiz(){
  var q=$('.pc-quiz');if(!q)return;
  var opts=$$('.pc-quiz__option',q),res=$('.pc-quiz__result',q),ow=$('.pc-quiz__options',q),rst=$('[data-quiz-reset]',q);
  if(!opts.length)return;
  for(var i=0;i<opts.length;i++){
    opts[i].addEventListener('click',function(){
      for(var j=0;j<opts.length;j++)opts[j].classList.remove('pc-quiz__option--selected');
      this.classList.add('pc-quiz__option--selected');
      var h=this.getAttribute('data-quiz-product');if(!h)return;
      if(res){res.hidden=false;res.classList.add('pc-quiz__result--visible');}if(ow)ow.hidden=true;
      var cards=$$('[data-quiz-result-product]',q);for(var k=0;k<cards.length;k++)cards[k].hidden=cards[k].getAttribute('data-quiz-result-product')!==h;
      announce('Product recommendation shown');
    });
  }
  if(rst)rst.addEventListener('click',function(e){e.preventDefault();if(res){res.hidden=true;res.classList.remove('pc-quiz__result--visible');}if(ow)ow.hidden=false;for(var m=0;m<opts.length;m++)opts[m].classList.remove('pc-quiz__option--selected');announce('Quiz reset');});
}

// Before/After Slider

function initBeforeAfter(){var cs=$$('.pc-before-after');for(var i=0;i<cs.length;i++)setupBA(cs[i]);}

function setupBA(ctr){
  var handle=$('.pc-before-after__handle',ctr),after=$('.pc-before-after__after',ctr);if(!handle||!after)return;
  var dragging=false,pct=50;
  function setPos(p){pct=Math.max(0,Math.min(100,p));handle.style.left=pct+'%';var c='inset(0 '+(100-pct)+'% 0 0)';after.style.clipPath=c;after.style.webkitClipPath=c;}
  function pctEvt(e){var r=ctr.getBoundingClientRect();return((e.clientX||0)-r.left)/r.width*100;}
  handle.addEventListener('pointerdown',function(e){e.preventDefault();dragging=true;handle.setPointerCapture(e.pointerId);ctr.classList.add('pc-before-after--dragging');});
  ctr.addEventListener('pointermove',function(e){if(!dragging)return;e.preventDefault();setPos(pctEvt(e));});
  ctr.addEventListener('pointerup',function(e){if(!dragging)return;dragging=false;try{handle.releasePointerCapture(e.pointerId);}catch(x){}ctr.classList.remove('pc-before-after--dragging');});
  ctr.addEventListener('click',function(e){if(e.target===handle||dragging)return;setPos(pctEvt(e));});
  handle.tabIndex=0;handle.setAttribute('role','slider');handle.setAttribute('aria-label','Before and after comparison');
  handle.setAttribute('aria-valuemin','0');handle.setAttribute('aria-valuemax','100');handle.setAttribute('aria-valuenow','50');
  handle.addEventListener('keydown',function(e){
    var n=pct;if(e.key==='ArrowLeft'||e.key==='Left')n-=2;else if(e.key==='ArrowRight'||e.key==='Right')n+=2;else if(e.key==='Home')n=0;else if(e.key==='End')n=100;else return;
    e.preventDefault();setPos(n);handle.setAttribute('aria-valuenow',String(Math.round(pct)));
  });
  setPos(50);
  var tabs=$$('.pc-before-after__tab',ctr),panels=$$('.pc-before-after__panel',ctr);
  if(tabs.length&&panels.length){for(var t=0;t<tabs.length;t++){tabs[t].addEventListener('click',function(){
    var idx=this.getAttribute('data-tab-index');
    for(var a=0;a<tabs.length;a++){tabs[a].classList.toggle('pc-before-after__tab--active',tabs[a]===this);tabs[a].setAttribute('aria-selected',tabs[a]===this?'true':'false');}
    for(var b=0;b<panels.length;b++)panels[b].hidden=panels[b].getAttribute('data-panel-index')!==idx;
  });}}
}

// FAQ Accordion

function initFAQ(){
  var cs=$$('.pc-faq,[data-faq-exclusive]');
  for(var i=0;i<cs.length;i++){var excl=cs[i].hasAttribute('data-faq-exclusive'),items=$$('details.pc-faq__item',cs[i]);
    for(var j=0;j<items.length;j++){(function(all,cur,ex){cur.addEventListener('toggle',function(){if(!cur.open||!ex)return;for(var k=0;k<all.length;k++)if(all[k]!==cur&&all[k].open)all[k].open=false;});})(items,items[j],excl);}}
  var sums=$$('details.pc-faq__item > summary');
  for(var s=0;s<sums.length;s++){sums[s].setAttribute('role','button');sums[s].setAttribute('aria-expanded',sums[s].parentElement.open?'true':'false');sums[s].addEventListener('click',function(){this.setAttribute('aria-expanded',this.parentElement.open?'false':'true');});}
}

// Quick Add

function initQuickAdd(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-quick-add]');if(!btn)return;e.preventDefault();
    var vid=parseInt(btn.getAttribute('data-variant-id'),10);if(isNaN(vid))return;
    var orig=btn.textContent;btn.disabled=true;btn.classList.add('pc-btn--loading');btn.setAttribute('aria-busy','true');
    var cfg=fetchCfg();cfg.body=JSON.stringify({items:[{id:vid,quantity:1}]});
    fetch(u('/cart/add.js'),cfg)
      .then(function(r){if(!r.ok)return r.json().then(function(d){throw new Error(d.description||d.message||'Could not add');});return r.json();})
      .then(function(){btn.textContent='Added!';btn.classList.add('pc-btn--success');announce('Item added to cart');return refreshCart();})
      .then(function(){openCart();setTimeout(function(){btn.textContent=orig;btn.classList.remove('pc-btn--success');},1500);})
      .catch(function(er){btn.textContent='Error';announce('Error: '+(er.message||'Could not add'));setTimeout(function(){btn.textContent=orig;},2000);})
      .finally(function(){btn.disabled=false;btn.classList.remove('pc-btn--loading');btn.setAttribute('aria-busy','false');});
  });
}

// Product Image Gallery

function initBundleSave(){
  var root=$('[data-bundle-save]');if(!root)return;
  var mapEl=$('[data-bundle-map]',root),map;
  try{map=JSON.parse(mapEl.textContent);}catch(e){return;}
  var idInput=$('input[name="id"][type="hidden"]'),qtyInput=$('input[name="quantity"]');
  var tiers=$$('.pc-tier',root),picks=$$('[data-pack-size]',root);
  var t2p=$('[data-tier2-price]',root),t2c=$('[data-tier2-compare]',root),t2s=$('[data-tier2-save]',root);
  var t1p=$('[data-tier1-price]',root);

  function packKey(){return picks[0].value+'-'+picks[1].value;}
  function currentSize(){
    var sel=$('[data-variant-option].pc-variant-option--selected');
    return sel?String(parseInt(sel.getAttribute('data-value'),10)):'250';
  }
  function tier(){var r=$('.pc-tier__radio:checked',root);return r?r.value:'1';}

  function apply(){
    var p=map.packs[packKey()];
    if(p){
      t2p.textContent=formatMoney(p.price);
      t2c.textContent=formatMoney(p.compare);
      t2s.textContent='Save '+formatMoney(p.compare-p.price);
    }
    var size=currentSize();
    if(map.singlePrice[size]!=null)t1p.textContent=formatMoney(map.singlePrice[size]);
    var t1c=$('[data-tier1-compare]',root),t1s=$('[data-tier1-save]',root),sc=map.singleCompare?map.singleCompare[size]:0,sp=map.singlePrice[size];
    if(t1c){if(sc&&sc>sp){t1c.textContent=formatMoney(sc);t1c.hidden=false;if(t1s)t1s.textContent='Save '+formatMoney(sc-sp);}else{t1c.hidden=true;}}

    for(var i=0;i<tiers.length;i++){
      var on=tiers[i].getAttribute('data-tier')===tier();
      tiers[i].classList.toggle('pc-tier--selected',on);
    }
    /* The form posts whatever is in the hidden id, so point it at the pack or
       the single variant. Quantity stays 1 — a twin pack is one line item. */
    if(!idInput)return;
    if(tier()==='2'&&p){idInput.value=p.id;}
    else if(map.single[size]){idInput.value=map.single[size];}
    if(qtyInput)qtyInput.value=1;
  }

  for(var i=0;i<picks.length;i++)picks[i].addEventListener('change',apply);
  root.addEventListener('change',function(e){if(e.target.name==='pc-tier')apply();});
  /* clicking a size pill must also refresh the tier prices and defaults */
  document.addEventListener('click',function(e){
    if(!e.target.closest('[data-variant-option]'))return;
    setTimeout(function(){
      var size=currentSize();
      for(var j=0;j<picks.length;j++)picks[j].value=size;
      apply();
    },0);
  });
  apply();
}

function initCardSizes(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-card-size]');if(!btn)return;
    e.preventDefault();
    var card=btn.closest('.pc-product-card');if(!card)return;
    var all=$$('[data-card-size]',card);
    for(var i=0;i<all.length;i++){
      all[i].classList.toggle('pc-card-size--active',all[i]===btn);
      all[i].setAttribute('aria-pressed',all[i]===btn?'true':'false');
    }
    var price=$('[data-card-price]',card);
    if(price)price.textContent=btn.getAttribute('data-price')||price.textContent;
    var cmp=$('[data-card-compare]',card),cv=btn.getAttribute('data-compare');
    if(cmp){
      if(cv){var s=cmp.querySelector('s');if(s)s.textContent=cv;cmp.hidden=false;}
      else cmp.hidden=true;
    }
    var badge=$('[data-card-badge]',card),sv=btn.getAttribute('data-save');
    if(badge){if(sv){badge.textContent=sv;badge.hidden=false;}else badge.hidden=true;}
    /* the card photo follows the size; on cross-product bundles the hover
       photo becomes whichever size is NOT selected */
    var img=$('[data-card-image]',card),src=btn.getAttribute('data-image');
    if(img&&src){img.src=src;var ss=btn.getAttribute('data-srcset');if(ss)img.srcset=ss;}
    if(card.getAttribute('data-hover-mode')==='alt-size'){
      var hv=$('[data-card-hover-image]',card),other=null;
      for(var k=0;k<all.length;k++)if(all[k]!==btn&&all[k].getAttribute('data-image')){other=all[k];break;}
      if(hv&&other){hv.src=other.getAttribute('data-image');hv.srcset=other.getAttribute('data-srcset')||'';}
    }
    var add=$('[data-quick-add]',card);
    if(add){
      add.setAttribute('data-variant-id',btn.getAttribute('data-variant-id'));
      var avail=btn.getAttribute('data-available')!=='false';
      add.disabled=!avail;
      add.textContent=avail?'Add to Cart':'Sold Out';
    }
  });
}

function initProductGallery(){
  var thumbs=$$('.pc-product__media-thumb'),mainImg=$('.pc-product__media-main img');
  if(!thumbs.length||!mainImg)return;mainImg.style.transition='opacity 0.2s ease';
  for(var i=0;i<thumbs.length;i++){thumbs[i].addEventListener('click',function(e){
    e.preventDefault();var src=this.getAttribute('data-full-src');if(!src)return;
    mainImg.style.opacity='0';var self=this;
    setTimeout(function(){mainImg.src=src;var ss=self.getAttribute('data-full-srcset');if(ss)mainImg.srcset=ss;var alt=self.getAttribute('data-alt')||self.getAttribute('alt')||'';if(alt)mainImg.alt=alt;mainImg.style.opacity='1';},200);
    for(var j=0;j<thumbs.length;j++){thumbs[j].classList.remove('pc-product__media-thumb--active');thumbs[j].setAttribute('aria-current','false');}
    this.classList.add('pc-product__media-thumb--active');this.setAttribute('aria-current','true');
  });}
}

// Announcement Marquee

function initAnnouncementMarquee(){
  var mq=$('.pc-announcement__marquee');if(!mq)return;
  var inner=$('.pc-announcement__marquee-inner',mq);if(!inner||inner.getAttribute('data-duplicated'))return;
  inner.innerHTML+=inner.innerHTML;inner.setAttribute('data-duplicated','true');
}

// Init

document.addEventListener('DOMContentLoaded',function(){
  initScrollReveal();initStickyHeader();initCartDrawer();initProductForm();initStickyATC();
  initQuiz();initBeforeAfter();initFAQ();initQuickAdd();initCardSizes();initBundleSave();initProductGallery();initAnnouncementMarquee();
});

// Global Event Delegation

document.body.addEventListener('click',function(e){
  var el=e.target.closest('[data-action]');if(!el)return;var a=el.getAttribute('data-action');
  if(a==='toggle-menu'){e.preventDefault();toggleMenu();}
  else if(a==='open-cart'){e.preventDefault();openCart();}
  else if(a==='close-cart'){e.preventDefault();closeCart();}
  else if(a==='close-menu'){e.preventDefault();closeMenu();}
});
document.addEventListener('keydown',function(e){if(e.key!=='Escape'&&e.key!=='Esc')return;if(cartOpen)closeCart();else if(menuOpen)closeMenu();});
document.addEventListener('click',function(e){
  if(e.target.classList.contains('pc-cart-drawer__overlay')){closeCart();return;}
  if(e.target.classList.contains('pc-overlay')&&e.target.classList.contains('pc-overlay--active')){if(cartOpen)closeCart();else if(menuOpen)closeMenu();}
});
})();
